import { useEffect } from "react";

export default function Cookie() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legal">
            <div className="container">
                <h1>Cookie Policy – CloTech AI Pvt. Ltd.</h1>
                <p><strong>Effective Date:</strong> 18.09.2025<br /><strong>Last Updated:</strong> 18.09.2025</p>
                <p>This Cookie Policy explains how CloTech AI Pvt. Ltd. (“CloTech AI”, “we”, “our”, “us”) uses cookies and similar technologies on our website <a href="https://clotechai.com">https://clotechai.com</a> (“Site”) and CRM platform.</p>
                <hr />
                <h2>1. What Are Cookies?</h2>
                <p>Cookies are small text files stored on your device (computer, mobile, tablet) when you visit a website. They help websites recognize your device, store preferences, and enhance the user experience.</p>
                <hr />
                <h2>2. Types of Cookies We Use</h2>
                <ul>
                    <li><strong>Essential Cookies</strong> – Required for login, account security, and core website/CRM functions. Without these, services cannot function properly.</li>
                    <li><strong>Functional Cookies</strong> – Remember your preferences (e.g., language, region, login details) to improve usability.</li>
                    <li><strong>Analytics Cookies</strong> – Collect anonymous data about site usage (traffic, pages visited, performance). We may use third-party tools like Google Analytics.</li>
                    <li><strong>Marketing/Advertising Cookies</strong> – Used to show relevant ads, track campaigns, and measure engagement.</li>
                </ul>
                <hr />
                <h2>3. Third-Party Cookies</h2>
                <ul>
                    <li><strong>Google Analytics / Ads</strong> – for usage tracking and marketing.</li>
                    <li><strong>Social Media Plugins</strong> (Facebook, LinkedIn, Instagram, X/Twitter) – to enable sharing and engagement.</li>
                    <li><strong>Payment & Messaging Providers</strong> – where applicable for checkout and CRM-integrated communications.</li>
                </ul>
                <hr />
                <h2>4. How We Use Cookies</h2>
                <ul>
                    <li>Keep you logged in securely.</li>
                    <li>Provide smooth navigation across the CRM.</li>
                    <li>Analyze site and CRM usage for improvements.</li>
                    <li>Deliver relevant marketing and communication.</li>
                </ul>
                <hr />
                <h2>5. Managing Cookies</h2>
                <ul>
                    <li>You can manage or disable cookies in your browser settings at any time.</li>
                    <li>Please note: disabling essential cookies may affect CRM functionality and access.</li>
                </ul>
                <hr />
                <h2>6. Consent</h2>
                <p>By using our Site and Services, you consent to the placement of cookies on your device in accordance with this policy.</p>
                <hr />
                <h2>7. Changes to This Policy</h2>
                <p>We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>
                <hr />
                <h2>8. Contact &amp; Communication Address</h2>
                <p>
                    For any questions or concerns regarding these Terms, please <a href="/contact">contact us</a>.
                </p>
            </div>
        </div>
    );
}
